var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeClose = function SvgEyeClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.638 3.577a.75.75 0 0 0-1.06 1.06l1.275 1.277a8.03 8.03 0 0 0-2.437 3.545.75.75 0 0 0 0 .487 8.02 8.02 0 0 0 11.083 4.614l1.864 1.863a.75.75 0 1 0 1.06-1.06zm7.723 9.844-1.914-1.913q-.212.052-.44.053h-.015a1.858 1.858 0 0 1-1.803-2.312l-2.27-2.27a6.53 6.53 0 0 0-1.996 2.723 6.52 6.52 0 0 0 8.438 3.72m3.716-3.719a6.5 6.5 0 0 1-1.257 2.03l1.061 1.06a8 8 0 0 0 1.704-2.846.75.75 0 0 0 0-.487A8.02 8.02 0 0 0 7.522 4.433l1.23 1.23q.607-.12 1.248-.12a6.52 6.52 0 0 1 6.077 4.16",
    clipRule: "evenodd"
  })));
};
export default SvgEyeClose;